// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","802":"94726e6d","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"a34b07f2376ed220c740","532":"9a44b0c96edc28263ac1","678":"58799711b5a24d1835b6","802":"5c40608f91e281b6360f","883":"f2fd5f21fcea7f91cbd4"}[chunkId] + ".js";
};